import { createStyles } from 'antd-style';

import { ThemeColors, ThemeSpaces } from '../../theme';

export const useCollapsibleMapCardStyles = createStyles(({ token }) => ({
  collapsibleMapCard: {
    display: 'flex',
    flexDirection: 'column',

    height: 21,
    transition: `height ${token.motionDurationMid} ease-in-out`,
  },
  collapseControl: {
    marginTop: -ThemeSpaces.SPACE_SM,
    color: ThemeColors.COLOR_RED,
    fontSize: token.fontSize,
    fontWeight: 500,
  },
  collapseContent: {
    flex: 1,
    opacity: 1,
    transition: `opacity ${token.motionDurationMid} ease-in-out`,

    '&.hidden': {
      opacity: 0,
    },
  },
}));
